import React, { InputHTMLAttributes } from 'react';
import DateInput from '../DateInput/DateInput';
import './Input.scss';

/**
 * Input Component
 * Reusable input field with label and error handling
 */

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  fullWidth?: boolean;
  compact?: boolean;
}

const Input: React.FC<InputProps> = ({
  label,
  error,
  fullWidth = false,
  compact = false,
  className = '',
  id,
  type,
  ...props
}) => {
  const inputId = id || `input-${label?.toLowerCase().replace(/\s/g, '-')}`;

  if (type === 'date') {
    const p = props as React.InputHTMLAttributes<HTMLInputElement>;
    const strVal =
      typeof p.value === 'string'
        ? p.value
        : p.value === undefined || p.value === null
          ? ''
          : String(p.value);

    return (
      <DateInput
        id={inputId}
        label={label}
        error={error}
        fullWidth={fullWidth}
        compact={compact}
        className={className}
        value={strVal}
        onChange={(iso) => {
          p.onChange?.({
            target: { value: iso, name: p.name } as HTMLInputElement,
            currentTarget: { value: iso, name: p.name } as HTMLInputElement,
          } as React.ChangeEvent<HTMLInputElement>);
        }}
        min={p.min as string | undefined}
        max={p.max as string | undefined}
        placeholder={p.placeholder}
        disabled={p.disabled}
        required={p.required}
        name={p.name}
        autoFocus={p.autoFocus}
        autoComplete={p.autoComplete}
        aria-label={p['aria-label']}
        aria-describedby={p['aria-describedby']}
      />
    );
  }

  return (
    <div className={`input-group ${fullWidth ? 'input-group--full-width' : ''} ${compact ? 'input-group--compact' : ''} ${className}`.trim()}>
      {label && (
        <label htmlFor={inputId} className="input-group__label">
          {label}
          {props.required && <span className="input-group__required">*</span>}
        </label>
      )}
      <input
        id={inputId}
        className={`input-group__input ${error ? 'input-group__input--error' : ''}`}
        type={type}
        {...props}
      />
      {error && <span className="input-group__error">{error}</span>}
    </div>
  );
};

export default Input;

